import { createSlice } from "@reduxjs/toolkit";
import { ApplicationsReducerState } from "types/application";
import { fetchApplicationsThunk } from "./thunk";
import { ERROR } from "types";

const initialState: ApplicationsReducerState = {
    loading: false,
    error: null,
    applications: [],
    last_fetched_at: null,
    count: 0,
}

const applicationsSlice = createSlice({
    name: 'applications',
    initialState,
    reducers: {
        markApplicationsExpired: (state) => {
            state.last_fetched_at = null;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchApplicationsThunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchApplicationsThunk.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.error = null;
                state.applications = payload.applications;
                state.last_fetched_at = Date.now();
                state.count = payload.count;
            })
            .addCase(fetchApplicationsThunk.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = "Failed to fetch applications";
            })
    }
})

export const { markApplicationsExpired } = applicationsSlice.actions;
export default applicationsSlice.reducer;